import React, { Fragment, useContext, useEffect  } from 'react';
import { ApplicationContext } from '../../context/Contexts';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Hidden, IconButton, Box, Tabs, Tab, Popover, Badge, makeStyles } from '@material-ui/core';
import { ReactComponent as BellSvg } from '../../assets/images/icons/bell-solid-full.svg';
import PollIcon from '@material-ui/icons/Poll';
import TabPanel from '../../components/_shared/Tabs';
import { connect } from 'react-redux';
import helpLogo from '../../assets/images/info.svg';
import MenuBookOutlinedIcon from '@material-ui/icons/MenuBookOutlined';

import { CountryCodeEnum } from '../../helpers/Constants';
import { withRouter } from 'react-router';
import { AppActionCreators } from '../../store';
import { useHistory } from 'react-router-dom'; // Import useHistory hook
import { TranslatorService } from '../../services/TranslatorService';
import { useAppDispatch, useAppSelector } from '../../store/configureStore';
import {
  AGENDA_SET_SELECTED_RANGE
} from '../../store/actions/ActionTypes';
import NotificationsDisplay from '../../components/cases/NotificationsDisplay';
import { ReactComponent as EnvelopeSvg } from '../../assets/images/icons/envelope-solid-full.svg';


// 1-1 cu MUI Badge (color primary) din CA2 Notification.tsx
const useBadgeStyles = makeStyles({
  badge: {
    backgroundColor: 'var(--primary)',
    color: '#fff',
    fontWeight: 500,
    fontSize: '0.75rem'
  }
});

const HeaderDots = (props) => {
  const context = useContext(ApplicationContext);
  const translatorService = new TranslatorService();
  const badgeClasses = useBadgeStyles();

  const { appState  } = props;
  const history = useHistory(); // Initialize useHistory
  const dispatch = useAppDispatch();

  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [anchorEl3, setAnchorEl3] = React.useState(null);

  useEffect(() => {
    console.log('HeaderDots mounted');
    // Call loadUserNotifications on component mount
    

    // Listen for navigation changes
    const unlisten = history.listen(() => {
      console.log('Navigation occurred');
      dispatch({
        type: AGENDA_SET_SELECTED_RANGE,
        payload: null
      });    
    });

    // Cleanup
    return () => {
      unlisten();
    };
  }, [history]); // Include loadUserNotifications and history in the dependency array


  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
  };


  const handleClick3 = (event) => {
    setAnchorEl3(event.currentTarget);
  };
  const handleClose3 = () => {
    setAnchorEl3(null);
  };
  const open1 = Boolean(anchorEl1);
  const open3 = Boolean(anchorEl3);

  const [value, setValue] = React.useState(0);
  const [countValue, setNewCasesCount] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const useStyle = makeStyles({
    indicator: {
      width: '100% !important'
    }
  });
  const useStyle2 = makeStyles({
    indicator: {
      width: '100% !important'
    }
  });

  const useStyle3 = makeStyles({
    indicator: {
      width: '100% !important'
    }
  });

  const classes = useStyle();
  const classes2 = useStyle2();
  const classes3 = useStyle3();

  const checkSelectedTab = () => {
    // let tabContainer = document.getElementById('tabs-container');
    // let secondTabSelected = tabContainer
    //   .getElementsByTagName('button')[1]
    //   .getAttribute('aria-selected');
    // let thirdTabSelected = tabContainer
    //   .getElementsByTagName('button')[2]
    //   .getAttribute('aria-selected');

    // if (secondTabSelected === 'true') {
    //   document.getElementById('tabs-container').getElementsByTagName('span')[6].style.left = '33.33%';
    // } else if (thirdTabSelected === 'true') {
    //   document.getElementById('tabs-container').getElementsByTagName('span')[6].style.left = '66.66%'; 
    // }
  };

  const checkSelectedTab2 = () => {
    // let tabContainer = document.getElementById('tabs-container');
    // let casesTabSelected = tabContainer
    //   .getElementsByTagName('button')[1]
    //   .getAttribute('aria-selected');

    // if (casesTabSelected === 'true') {
    //   document.getElementById('tabs-container').getElementsByTagName('span')[4].style.left = '50%';
    // }
  };

  return (
    <Fragment>
      <div className="d-flex align-items-center popover-header-wrapper">
      {props.appState.appUser?.organization?.country?.code?.toUpperCase() === CountryCodeEnum.CZ.toString() ? (
        <Hidden smDown>
          <Box component="span" pr="2">
            <IconButton onClick={handleClick3} color="inherit" className="btn-inverse mx-1 d-50">
              <Badge
                classes={{ badge: badgeClasses.badge }}
                badgeContent={props.appState.userNotifications.filter(item => !item.read).length}
              >
                <BellSvg width={30} height={30} />
              </Badge>
            </IconButton>
            <Popover
              onEntering={checkSelectedTab2}
              open={open3}
              anchorEl={anchorEl3}
              onClose={handleClose3}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
              classes={{
                paper: 'app-header-dots'
              }}
            >
              <div className="popover-custom-xl overflow-hidden">
                <div className="mx-2">
                  <Tabs
                    classes={{ indicator: classes3.indicator }}
                    id="tabs-container"
                    value={value}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    onChange={handleChange}
                  >
                    <Tab
                      className="py-3"
                      label={translatorService.Tranlate('NOTIFICATIONS', 'Notifications')}
                    />
                  </Tabs>
                </div>
                <div className="height-560">
                  <PerfectScrollbar>
                    <NotificationsDisplay onClick={handleClose1}></NotificationsDisplay>
                  </PerfectScrollbar>
                </div>
              </div>
            </Popover>
          </Box>
        </Hidden>
        ) : (
        <Hidden smDown>
          <Box component="span" pr="2">
            <IconButton onClick={handleClick1} color="inherit" className="btn-inverse mx-1 d-50">
              <Badge
                classes={{ badge: badgeClasses.badge }}
                badgeContent={props.appState.userNotifications.filter(item => !item.read).length}
              >
                <BellSvg width={30} height={30} />
              </Badge>
            </IconButton>
            <Popover
              onEntering={checkSelectedTab}
              open={open1}
              anchorEl={anchorEl1}
              onClose={handleClose1}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
              }}
              classes={{
                paper: 'app-header-dots'
              }}
            >
              <div className="popover-custom-xl overflow-hidden">
                <div className="mx-2">
                  <Tabs
                    classes={{ indicator: classes2.indicator }}
                    id="tabs-container"
                    value={value}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                    onChange={handleChange}
                  >
                   <Tab
                      className="py-3"
                      label={translatorService.Tranlate('NOTIFICATIONS', 'Notifications')}
                    />                    
                  </Tabs> 
                </div>
                <div className="height-560">
                  <PerfectScrollbar>                    
                    <NotificationsDisplay onClick={handleClose1} ></NotificationsDisplay>
                  </PerfectScrollbar>                  
                </div> 
              </div>
            </Popover>
          </Box>
        </Hidden>
        )}
        <Box component="span" pr="2">
          <IconButton onClick={() =>  {
              props.history.push('/user-manual');
            }} 
            color="inherit"
            className="btn-inverse mx-1 d-50 d-none d-sm-inline-flex">
            <MenuBookOutlinedIcon color="inherit" style={{ fontSize: 30 }} />
          </IconButton>
          <IconButton onClick={() =>  {
              props.history.push('/general-notification');
            }} 
            color="inherit"
            className="btn-inverse mx-1 d-50">
              <EnvelopeSvg width={30} height={30} />
          </IconButton>
          
        </Box>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.app.user,
  appState: state.app
});

const mapDispatchToProps = (dispatch) => ({
  loadUserNotifications: () => dispatch(AppActionCreators.LoadUserNotifications())
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HeaderDots));
